export function isInputElement(target: Maybe<HTMLElement | null>): target is HTMLInputElement {
    return Boolean(target && target.tagName === 'INPUT');
}

export function isTextareaElement(target: Maybe<HTMLElement | null>): target is HTMLTextAreaElement {
    return Boolean(target && target.tagName === 'TEXTAREA');
}

export function isInputableElement(target: Maybe<HTMLElement | null>) {
    return Boolean(
        target &&
            ((isInputElement(target) && target.type === 'text') ||
                isTextareaElement(target) ||
                target.isContentEditable)
    );
}
